var _defs, _rect, _rect2, _rect3, _rect4, _g, _circle, _g2, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _path, _circle2, _rect12, _rect13, _rect14, _rect15, _rect16, _circle3, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _path2, _path3, _g3, _circle4, _path4, _g4, _circle5, _circle6, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResumeIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 520 640",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "shadow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 12,
    stdDeviation: 14,
    floodColor: "#111827",
    floodOpacity: 0.18
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dots",
    width: 18,
    height: 18,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2,
    fill: "#FDE801"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "avatar"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 162,
    cy: 134,
    r: 34
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 70,
    width: 420,
    height: 500,
    rx: 210,
    fill: "#FEF9C3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 330,
    width: 84,
    height: 84,
    fill: "url(#dots)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 420,
    y: 150,
    width: 84,
    height: 84,
    fill: "url(#dots)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 58,
    width: 310,
    height: 500,
    rx: 16,
    fill: "#FDE801",
    transform: "rotate(-6 267 308)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 70,
    width: 312,
    height: 500,
    rx: 16,
    fill: "#FFFFFF"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 162,
    cy: 134,
    r: 34,
    fill: "#111827"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#avatar)",
    fill: "#FDE801"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 162,
    cy: 126,
    r: 13
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 162,
    cy: 166,
    rx: 26,
    ry: 20
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 214,
    y: 110,
    width: 150,
    height: 14,
    rx: 7,
    fill: "#111827"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 214,
    y: 134,
    width: 110,
    height: 9,
    rx: 4.5,
    fill: "#FDE801"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 214,
    y: 153,
    width: 46,
    height: 6,
    rx: 3,
    fill: "#D1D5DB"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 153,
    width: 58,
    height: 6,
    rx: 3,
    fill: "#D1D5DB"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 334,
    y: 153,
    width: 40,
    height: 6,
    rx: 3,
    fill: "#D1D5DB"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 190,
    width: 264,
    height: 2,
    fill: "#E5E7EB"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 212,
    width: 84,
    height: 10,
    rx: 5,
    fill: "#111827"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M138 246v104",
    stroke: "#E5E7EB",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 138,
    cy: 250,
    r: 8,
    fill: "#FDE801",
    stroke: "#111827",
    strokeWidth: 3
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 244,
    width: 124,
    height: 9,
    rx: 4.5,
    fill: "#111827"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 245,
    width: 62,
    height: 7,
    rx: 3.5,
    fill: "#FDE801"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 263,
    width: 232,
    height: 6,
    rx: 3,
    fill: "#D1D5DB"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 277,
    width: 204,
    height: 6,
    rx: 3,
    fill: "#D1D5DB"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 291,
    width: 170,
    height: 6,
    rx: 3,
    fill: "#D1D5DB"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 138,
    cy: 326,
    r: 8,
    fill: "#FFFFFF",
    stroke: "#111827",
    strokeWidth: 3
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 320,
    width: 104,
    height: 9,
    rx: 4.5,
    fill: "#111827"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 339,
    width: 220,
    height: 6,
    rx: 3,
    fill: "#D1D5DB"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 353,
    width: 150,
    height: 6,
    rx: 3,
    fill: "#D1D5DB"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 386,
    width: 56,
    height: 10,
    rx: 5,
    fill: "#111827"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 410,
    width: 64,
    height: 22,
    rx: 11,
    fill: "#FEF08A"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 410,
    width: 48,
    height: 22,
    rx: 11,
    fill: "#FEF08A"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 410,
    width: 76,
    height: 22,
    rx: 11,
    fill: "#FEF08A"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 340,
    y: 410,
    width: 52,
    height: 22,
    rx: 11,
    fill: "#FEF08A"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 440,
    width: 52,
    height: 22,
    rx: 11,
    fill: "#FEF08A"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 440,
    width: 80,
    height: 22,
    rx: 11,
    fill: "#FEF08A"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 440,
    width: 58,
    height: 22,
    rx: 11,
    fill: "#FEF08A"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 488,
    width: 76,
    height: 10,
    rx: 5,
    fill: "#111827"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 512,
    width: 150,
    height: 7,
    rx: 3.5,
    fill: "#9CA3AF"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 528,
    width: 110,
    height: 6,
    rx: 3,
    fill: "#D1D5DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M388 520l-16 62 28-14 14 28 14-70z",
    fill: "#111827"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M440 520l16 62-28-14-14 28-14-70z",
    fill: "#111827"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 414,
    cy: 492,
    r: 46,
    fill: "#FDE801",
    stroke: "#111827",
    strokeWidth: 5
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 414,
    cy: 492,
    r: 33,
    stroke: "#111827",
    strokeWidth: 2,
    strokeDasharray: "3 6",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M396 493l12 12 24-26",
    stroke: "#111827",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-20 -58)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 196,
    width: 112,
    height: 64,
    rx: 16,
    fill: "#111827",
    transform: "rotate(-4 84 228)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-4 84 228)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 212,
    width: 32,
    height: 32,
    rx: 8,
    fill: "#FDE801"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54 229l6 6 11-13",
    stroke: "#111827",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 216,
    width: 38,
    height: 8,
    rx: 4,
    fill: "#F9FAFB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 232,
    width: 26,
    height: 6,
    rx: 3,
    fill: "#6B7280"
  })))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 452,
    cy: 96,
    r: 10,
    fill: "#111827"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 520,
    r: 8,
    fill: "#FDE801",
    stroke: "#111827",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M470 330l8 8m0-8l-8 8",
    stroke: "#111827",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60 96l8 8m0-8l-8 8",
    stroke: "#111827",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResumeIllustration);
export default __webpack_public_path__ + "static/media/resume-illustration.dab2c77643c67de66a7444c206aec42b.svg";
export { ForwardRef as ReactComponent };